import { render, staticRenderFns } from "./FmTag.vue?vue&type=template&id=5489a234&"
import script from "./FmTag.vue?vue&type=script&lang=js&"
export * from "./FmTag.vue?vue&type=script&lang=js&"
import style0 from "./FmTag.vue?vue&type=style&index=0&id=5489a234&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports